module.exports = __webpack_public_path__ + "img/icon-home.27843494.svg";